<div *ngIf="loading">
    <div class="loader-span"></div>
</div>

<div class="contents">
    <div class="modal-header">
        <h3 class="modal-title" id="spocEmailUpdateModalLabel">Update SPOC Email Address</h3>
    </div>
    <div class="modal-body">
        <form [formGroup]="spocEmailForm" (ngSubmit)="spocEmailSubmit(spocEmailForm.value)" id="spocEmailUpdateForm">
            <div class="row">
                <div class="col-12 pb-3">
                    <div
                        [class.err-input]="spocEmailForm.controls['email'].invalid && (spocEmailForm.controls['email'].dirty || spocEmailForm.controls['email'].touched)">
                        <label for="spocEmail">SPOC Email <span class="red-star">*</span></label>
                        <input class="form-control" type="text" name="spocEmail" id="spocEmail"
                            formControlName="email" placeholder="Enter SPOC Email Address" [maxLength]="emailMaxLength">
                    </div>
                    <div
                        *ngIf="spocEmailForm.controls['email'].invalid && (spocEmailForm.controls['email'].dirty || spocEmailForm.controls['email'].touched)">
                        <div *ngIf="spocEmailForm.controls['email'].errors?.required">
                            <span class="error sum">SPOC Email is required.</span>
                        </div>
                        <div *ngIf="spocEmailForm.controls['email'].errors?.maxlength">
                            <span class="error sum">SPOC Email cannot exceed {{ emailMaxLength }} characters.</span>
                        </div>
                    </div>
                    <span
                        *ngIf="spocEmailForm.controls['email'].errors && (spocEmailForm.controls['email'].errors.email || spocEmailForm.controls['email'].errors.pattern) && !spocEmailForm.controls['email'].errors.required && !spocEmailForm.controls['email'].errors.maxlength"
                        class="error sum">Invalid email address</span>
                </div>
            </div>
        </form>
    </div>
    <footer class="modal-footer">
        <button type="button" class="btn btn-cancel" (click)="modal.dismissAll()">Cancel</button>
        <button type="submit" class="btn btn-save" form="spocEmailUpdateForm"
            [disabled]="spocEmailForm.get('email')?.invalid || loading || !hasFormChanged()">Update</button>
    </footer>
</div>
